var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 911.543,
    height: 732.306,
    viewBox: "0 0 911.543 732.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.036,
    y1: 0.858,
    x2: -0.971,
    y2: 0.064,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#ffb180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#ffb88a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#ffc39b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#ffcaa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcda9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.744,
    y1: 1.514,
    x2: 0.164,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809",
    transform: "translate(16.754 98.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M130.67,738.763S-2.024,557.426,72.144,440.522,230.282,398.591,339,299.158c190.565-174.289,471.239-206.347,555.578-40.1,105.512,207.981-97.82,479.7-97.82,479.7L559.884,725.432Z",
    transform: "translate(-49.613 -104.862)",
    fill: "#ecc871",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806",
    transform: "translate(81.056 115.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M155.763,413.187s147.456-26.207,221.891-144.4l21.483-43.532,84.38-44.4s13.335,15.185-46.849,44.9l13.212,16-6.629,32.985-34.091,14.77-4.574,10.167-.44-.5C385.423,332.463,328.2,457.791,146.13,495.062,146.13,495.062,124.113,466.589,155.763,413.187Z",
    transform: "translate(-16.57 -180.86)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M243.441,219.408l39.6,17.218-8.091,3.505-2.573,5.719",
    transform: "translate(117.643 -131.477)",
    fill: "#ffa980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M237.945,235.264l12.537-15.857L286.8,247.653l-15.7,21.973",
    transform: "translate(110.602 -131.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M176.429,343.487S299.423,316.972,354.7,225.418l42.319,35.772s-85.55,133.569-189.463,159.14c-54.942-31.687-62.723-55.006-62.723-55.006",
    transform: "translate(-8.688 -123.777)",
    fill: "#130c28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    transform: "translate(8.682 38.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    "data-name": "Group 1798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    "data-name": "Group 1797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M259.469,301.789s28.776,13.271,38.753,61.167c6.716,32.229,5.573,84.549,5.573,176.055H97.85s-21.3-119.278,2.019-201.744c4.941-17.469,59.858-50.12,84.453-56.386l9.487,28.192,17.866,33.368,30.236,8.077,13.668-31.2",
    transform: "translate(-88.953 -91.366)",
    fill: "#131c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M201.445,354.753l-11.832-12.468,9.916-3.168c-7.012-29.515-19.17-44.367-30.115-51.831.094.538.171,1.084.228,1.633.29,2.835.493,5.675.719,8.515a14.713,14.713,0,0,1,.88,5.246,27.656,27.656,0,0,1-.292,3c.723,12,1.031,24.018,1.252,36.05.212,11.547-9.334,16.844-18.251,15.943l2.128,21.253,24.337,103.128C211.057,443,201.445,354.753,201.445,354.753Z",
    transform: "translate(-5.685 -83.162)",
    fill: "#133a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M131.087,262.44,131.7,340.5s22.165,24.816,67.967,35.008l-.278-61.334Z",
    transform: "translate(-34.975 -114.991)",
    fill: "#ffb097"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796",
    transform: "translate(47.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M292.015,223.816c-2.491-.7-117.1-58.893-155.141,1.081,0,0-55.419,43.573-7.256,103.924l14.848,20.09,12.541,1.421,13.7,17.19,27.382-72.012,62.262-32.287C244.1,242.7,254.126,266.408,292.015,223.816Z",
    transform: "translate(-109.943 -197.8)",
    fill: "#131637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M253.646,230.445l-9.736,139.4s-84.526,27.067-101.969-48.82c0,0-35.888-15.639-21.365-39.7,2.231-3.7,8.944-5.377,14.252-4.558a18.549,18.549,0,0,1,12.053,8.319,27.843,27.843,0,0,1,3.755,16.615s6.583-9.875,7.45-38.838c0,0,24.718-10.687,20.258-34.679,0,0,26.54,4.272,38.436-5.808C216.781,222.384,233.814,234.49,253.646,230.445Z",
    transform: "translate(-100.754 -166.306)",
    fill: "#ffcda9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M182.421,222.384c-11.9,10.08-38.436,5.808-38.436,5.808a28.911,28.911,0,0,1-.048,11.3c17.824,13.769,41.47,9.008,41.47,9.008l-11.613-13.456a78.962,78.962,0,0,0,44.4,11.006l1.088-15.6C199.454,234.49,182.421,222.384,182.421,222.384Z",
    transform: "translate(-66.394 -166.306)",
    fill: "#ffa980"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791",
    transform: "translate(87.897 102.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M167.795,257.1a3.025,3.025,0,0,1-3.025-3.022,5.124,5.124,0,1,0-10.249,0,3.022,3.022,0,1,1-6.045,0,11.171,11.171,0,1,1,22.341,0A3.023,3.023,0,0,1,167.795,257.1Z",
    transform: "translate(-148.476 -242.903)",
    fill: "#130c28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792",
    transform: "translate(128.172 102.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M185.451,257.1a3.025,3.025,0,0,1-3.025-3.022,5.124,5.124,0,1,0-10.249,0,3.022,3.022,0,1,1-6.045,0,11.17,11.17,0,1,1,22.341,0A3.023,3.023,0,0,1,185.451,257.1Z",
    transform: "translate(-166.132 -242.903)",
    fill: "#130c28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793",
    transform: "translate(125.194 81.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M189.863,249.312a3.755,3.755,0,0,0,2.667-5.983c-.328-.438-8.185-10.7-24.157-9.829a3.753,3.753,0,0,0,.411,7.5c12-.657,17.676,6.75,17.731,6.823A3.754,3.754,0,0,0,189.863,249.312Z",
    transform: "translate(-164.826 -233.447)",
    fill: "#130c28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794",
    transform: "translate(79.577 81.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M148.242,249.312a3.753,3.753,0,0,1-2.667-5.983c.326-.438,8.182-10.7,24.154-9.829a3.753,3.753,0,0,1-.411,7.5c-12-.657-17.676,6.75-17.731,6.823A3.75,3.75,0,0,1,148.242,249.312Z",
    transform: "translate(-144.829 -233.447)",
    fill: "#130c28"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M257.5,222.369s-6.273,19.458-29.862,24.159L245.711,257s-28.815,15.892-63.241,2.356l13.639,11.4s-27.663,10.463-48.633-6.309c-19.1-15.279-6.54-50.467-6.54-50.467l19.382-15.046Z",
    transform: "translate(-75.433 -196.354)",
    fill: "#131637"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1795",
    "data-name": "Group 1795",
    transform: "translate(8.095 105.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M114.525,257.147a1,1,0,0,0,.422-.114l13.794-7.4,57.787-3.723a.985.985,0,0,0-.114-1.966H186.4l-58,3.734a1.036,1.036,0,0,0-.4.112l-13.985,7.5a.985.985,0,0,0,.511,1.855Z",
    transform: "translate(-113.492 -243.94)",
    fill: "#002848"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M165.241,244.385l18.188,40.1H161.35Z",
    transform: "translate(-44.087 -138.121)",
    fill: "#ff7588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M205.271,270.517a1.133,1.133,0,0,0-.835-.5l-56.14-5.306a1.125,1.125,0,0,0-1.227,1.15c.007.251.992,25.261,22.964,28.434a35.554,35.554,0,0,0,5.08.374c22.412,0,30.2-22.939,30.284-23.187A1.128,1.128,0,0,0,205.271,270.517Z",
    transform: "translate(-62.382 -112.087)",
    fill: "#ffb097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M147.561,265.2l56.14,5.3s-8.435,25.763-34.139,22.051C148.268,289.479,147.561,265.2,147.561,265.2Z",
    transform: "translate(-61.751 -111.456)",
    fill: "#130c28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1799",
    "data-name": "Group 1799",
    transform: "translate(177.131 92.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M166.626,257.123a17.719,17.719,0,1,1,18.566,16.83A17.736,17.736,0,0,1,166.626,257.123Zm1.966-.1a15.752,15.752,0,1,0,14.964-16.5A15.772,15.772,0,0,0,168.592,257.027Z",
    transform: "translate(-166.605 -238.544)",
    fill: "#002848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1800",
    "data-name": "Group 1800",
    transform: "translate(128.165 92.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M145.16,256.833a17.719,17.719,0,1,1,18.566,16.825A17.747,17.747,0,0,1,145.16,256.833Zm1.966-.1a15.75,15.75,0,1,0,14.962-16.5A15.767,15.767,0,0,0,147.126,256.738Z",
    transform: "translate(-145.139 -238.249)",
    fill: "#002848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801",
    transform: "translate(161.443 101.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M176.849,246.61l1.026-1.681c-10.253-6.227-18.066.876-18.148.949l1.341,1.444C161.342,247.071,167.891,241.174,176.849,246.61Z",
    transform: "translate(-159.727 -242.374)",
    fill: "#002848"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M145.63,279.85s-25.747,9.355-25.651,71.989h15.454l-5.808,12.439s33.281,105.416,94.309,127.3L190.18,384.732",
    transform: "translate(-49.205 -92.687)",
    fill: "#133a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M126.754,290.105s17.9,96.269,88.5,188.331l6.015-129.6L194.149,337.2",
    transform: "translate(-40.526 -79.549)",
    fill: "#c3deff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M169.03,320.456l-11.15,1.22s-10.466,26.976-4.813,72.694a473.309,473.309,0,0,0,30.626,45.184l2.37-51.069C184.781,367.465,180.4,342.852,169.03,320.456Z",
    transform: "translate(-8.963 -40.667)",
    fill: "#ff840d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M170.7,340.551l18.592-21.127-21.127-8.654-21.127,8.654Z",
    transform: "translate(-14.541 -53.077)",
    fill: "#ffb40d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M194.15,350.336l-31.47,13.942s-59.064-56.436-25.728-84.428C136.951,279.85,149.924,314.967,194.15,350.336Z",
    transform: "translate(-40.527 -92.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M165.453,308.479,156.3,334.615l27.122,11.643s-1.8-22.907-16.255-54.137Z",
    transform: "translate(-2.676 -76.967)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M322.1,291.926H359l-36.9-45.591Z",
    transform: "translate(218.414 -96.98)",
    fill: "#fe7900"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 69.656,
    cy: 69.656,
    r: 69.656,
    transform: "translate(408.776 207.823) rotate(-76.538)",
    fill: "#ecc871"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(447.336 113.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 26.327,
    height: 7.613,
    rx: 1.603,
    transform: "translate(45.09 40.592) rotate(45)",
    fill: "#444242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M327.555,238.36a27.124,27.124,0,1,0,0,38.359A27.122,27.122,0,0,0,327.555,238.36ZM296.2,269.716a17.222,17.222,0,1,1,24.355,0A17.219,17.219,0,0,1,296.2,269.716Z",
    transform: "translate(-281.253 -230.415)",
    fill: "#444242"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 41.68,
    height: 16.387,
    rx: 3.45,
    transform: "translate(57.175 45.588) rotate(45)",
    fill: "#444242"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M304.173,220.818v21.893l27.048-21.893Z",
    transform: "translate(195.446 -129.671)",
    fill: "#060ec8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 363.895,
    height: 247.836,
    rx: 13.872,
    transform: "translate(295.155 202.198)",
    fill: "#d6f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M342.958,374.942a1.568,1.568,0,1,0,1.569-1.569A1.569,1.569,0,0,0,342.958,374.942Z",
    transform: "translate(245.133 65.766)",
    fill: "#0c314d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M338.915,374.942a1.568,1.568,0,1,0,1.567-1.569A1.569,1.569,0,0,0,338.915,374.942Z",
    transform: "translate(239.954 65.766)",
    fill: "#0c314d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M183.429,264.873H161.35S175.814,253.217,183.429,264.873Z",
    transform: "translate(12.477 -79.868)",
    fill: "#ff5988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M240.053,390.653l49.573-8.946,44.96,21.4,5.307,12.456H225.423",
    transform: "translate(94.56 76.442)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 14.433,
    height: 24.912,
    transform: "translate(320.18 467.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M99.653,313.462c13.506-20.151,45.823-28,69.208,43.318,28.2,86.02,68.04,135.072,231.442,130.754l-.265,33.391S178.12,586.107,106.9,424.668C93.943,398.549,78.295,342.231,99.653,313.462Z",
    transform: "translate(-80.055 -28.919)",
    fill: "#130c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    d: "M13.5,0H652.594a13.5,13.5,0,0,1,13.5,13.5V32.058a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V13.5A13.5,13.5,0,0,1,13.5,0Z",
    transform: "translate(0 486.287)",
    fill: "#fedb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M147.561,265.2a37.4,37.4,0,0,0,3.447,13.449l45,4.555a39.377,39.377,0,0,0,7.694-12.7Z",
    transform: "translate(-5.188 -72.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M148.095,269.531c9.679-1.866,33.9-4.916,53.343,5.97a33.756,33.756,0,0,0,2.263-5l-56.14-5.3A32,32,0,0,0,148.095,269.531Z",
    transform: "translate(-5.188 -72.814)",
    fill: "#d0eaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 76.405,
    height: 5.033,
    transform: "translate(434.454 481.255)",
    fill: "#bbd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M329.167,356.916a6.566,6.566,0,0,0-6.538-5.938H295.09a6.569,6.569,0,0,0-6.54,5.938l-8.926,92.3h58.469ZM308.66,397.236A8.036,8.036,0,1,1,316.7,389.2,8.035,8.035,0,0,1,308.66,397.236Z",
    transform: "translate(163.996 37.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 4.467,
    height: 15.188,
    transform: "translate(598.924 427.09)",
    fill: "#97b9d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 4.467,
    height: 15.188,
    transform: "translate(620.18 427.09)",
    fill: "#0c314d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 4.467,
    height: 15.188,
    transform: "translate(627.003 427.09)",
    fill: "#0c314d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 1.69,
    height: 15.188,
    transform: "translate(607.059 427.09)",
    fill: "#97b9d6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 9.726,
    cy: 9.726,
    r: 9.726,
    transform: "translate(320.533 408.513)",
    fill: "#f5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M243.749,369.183a8.851,8.851,0,1,1-8.851-8.853A8.85,8.85,0,0,1,243.749,369.183Z",
    transform: "translate(95.361 49.057)",
    fill: "#b8d4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 24.922,
    cy: 24.922,
    r: 24.922,
    transform: "matrix(0.974, -0.229, 0.229, 0.974, 54.144, 147.778)",
    fill: "#133a77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(68.943 37.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M120.566,325.47a4.8,4.8,0,0,1-4.754-4.236c-.226-2-5.217-49.347,24.9-86.4,14.9-18.333,35.056-30.441,61.628-35.587,12.083-2.34,17.982-2.366,21.985-.607,6.8,2.988,5,3.616,5.126,5.491-34.93,3.508-63.866,15.26-81.271,36.68-27.642,34.013-22.9,78.944-22.845,79.4a4.738,4.738,0,0,1-4.222,5.235A4.875,4.875,0,0,1,120.566,325.47Z",
    transform: "translate(-115.37 -197.396)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 21.31,
    cy: 21.31,
    r: 21.31,
    transform: "translate(56.564 145.03)",
    fill: "#ffb40d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 14.76,
    cy: 14.76,
    r: 14.76,
    transform: "translate(59.341 151.581)",
    fill: "#ffea1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 7.228,
    cy: 7.228,
    r: 7.228,
    transform: "translate(66.873 159.112)",
    fill: "#133a77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(72.16 164.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M197.726,314.814l-.048,0c-38.336-4.977-58.259-20.667-68.221-32.95-10.915-13.458-12.592-25.674-12.658-26.187a2.278,2.278,0,0,1,4.519-.586h0c.016.116,1.649,11.647,11.862,24.127,9.451,11.549,28.416,26.315,65.084,31.075a2.279,2.279,0,0,1-.538,4.526Z",
    transform: "translate(-116.781 -253.101)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    d: "M1.847,0H16.284A1.847,1.847,0,0,1,18.13,1.847V6.924A1.846,1.846,0,0,1,16.284,8.77H1.846A1.846,1.846,0,0,1,0,6.924V1.847A1.847,1.847,0,0,1,1.847,0Z",
    transform: "translate(150.475 219.562) rotate(8.352)",
    fill: "#ffb40d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M382.475,279.326h-36.9l36.9-45.591Z",
    transform: "translate(329.538 2.434)",
    fill: "#fe9900"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 47.692,
    cy: 47.692,
    rx: 47.692,
    ry: 47.692,
    transform: "matrix(0.236, -0.972, 0.972, 0.236, 762.93, 215.338)",
    fill: "#feba00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 43.766,
    cy: 43.766,
    r: 43.766,
    transform: "translate(771 414.711) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808",
    transform: "translate(245.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M176.9,177.977v36.9l45.591-36.9Z",
    transform: "translate(-131.976 -68.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 314.068,
    height: 113.989,
    rx: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    transform: "translate(24.037 31.406)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 18.094,
    cy: 18.094,
    r: 18.094,
    transform: "translate(0 25.589) rotate(-45)",
    fill: "#ecc871"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 18.094,
    cy: 18.094,
    r: 18.094,
    transform: "translate(55.712 25.589) rotate(-45)",
    fill: "#ecc871"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 18.094,
    cy: 18.094,
    r: 18.094,
    transform: "translate(115.257 39.06) rotate(-76.763)",
    fill: "#ecc871"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 18.094,
    cy: 18.094,
    r: 18.094,
    transform: "translate(165.35 24.074) rotate(-41.606)",
    fill: "#ecc871"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    transform: "translate(826.74 481.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M442.272,310.159c0,21.11-22.744,38.051-22.744,38.051s-22.745-13.887-22.745-38.051a22.745,22.745,0,0,1,45.49,0Z",
    transform: "translate(-396.783 -287.415)",
    fill: "#feba00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 19.67,
    cy: 19.67,
    r: 19.67,
    transform: "translate(3.075 3.074)",
    fill: "#fea200"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 9.772,
    cy: 9.772,
    r: 9.772,
    transform: "translate(12.973 12.972)",
    fill: "#fec400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M383.182,230.949v-6.484a16.545,16.545,0,0,0,2.894-1.2l4.589,4.589,6.947-6.947-4.589-4.589a16.527,16.527,0,0,0,1.206-2.9h6.484V203.6h-6.484a16.526,16.526,0,0,0-1.206-2.9l4.589-4.589-6.947-6.947-4.589,4.589a16.545,16.545,0,0,0-2.894-1.2v-6.485h-9.824v6.485a16.524,16.524,0,0,0-2.9,1.2l-4.589-4.589-6.947,6.947,4.589,4.589a16.52,16.52,0,0,0-1.2,2.9h-6.484v9.823h6.484a16.52,16.52,0,0,0,1.2,2.9l-4.589,4.589,6.947,6.947,4.589-4.589a16.524,16.524,0,0,0,2.9,1.2v6.484Zm-14.823-23.74a9.995,9.995,0,1,1,11.209,11.209A10.013,10.013,0,0,1,368.359,207.209Zm61.062,4.913v-4.728H426.3a8.016,8.016,0,0,0-.58-1.392l2.208-2.209-3.342-3.343-2.209,2.209a7.951,7.951,0,0,0-1.393-.58v-3.12h-4.727v3.12a7.952,7.952,0,0,0-1.393.58l-2.208-2.209-3.343,3.343L411.522,206a7.94,7.94,0,0,0-.58,1.392h-3.12v4.728h3.12a7.985,7.985,0,0,0,.58,1.393l-2.209,2.208,3.343,3.343,2.208-2.209a7.956,7.956,0,0,0,1.393.58v3.12h4.727v-3.12a7.954,7.954,0,0,0,1.393-.58l2.209,2.209,3.342-3.343-2.208-2.208a8.061,8.061,0,0,0,.58-1.393Zm-6.031-1.739A4.81,4.81,0,1,1,418,204.99,4.819,4.819,0,0,1,423.391,210.384Zm-32.357,39.57,2.893-2.893-1.911-1.912a6.894,6.894,0,0,0,.5-1.2h2.7v-4.093h-2.7a6.9,6.9,0,0,0-.5-1.206l1.911-1.911-2.893-2.894-1.912,1.912a6.875,6.875,0,0,0-1.206-.5v-2.7h-4.092v2.7a6.908,6.908,0,0,0-1.206.5l-1.911-1.912-2.894,2.894,1.912,1.911a6.822,6.822,0,0,0-.5,1.206h-2.7v4.093h2.7a6.813,6.813,0,0,0,.5,1.2l-1.912,1.912,2.894,2.893,1.911-1.911a6.908,6.908,0,0,0,1.206.5v2.7h4.092v-2.7a6.875,6.875,0,0,0,1.206-.5Zm-4.623-3.928A4.163,4.163,0,1,1,390,242.439,4.165,4.165,0,0,1,386.411,246.025Zm-21.71-5.54.83-.829-1.257-1.257-.829.83a2.941,2.941,0,0,0-.524-.218V237.84h-1.775v1.172a2.94,2.94,0,0,0-.524.218l-.829-.83-1.257,1.257.83.829a2.965,2.965,0,0,0-.218.523h-1.172v1.776h1.172a2.941,2.941,0,0,0,.218.524l-.83.829,1.257,1.255.829-.829a2.941,2.941,0,0,0,.524.218v1.172h1.775v-1.172a2.943,2.943,0,0,0,.524-.218l.829.829,1.257-1.255-.83-.829a2.941,2.941,0,0,0,.218-.524h1.172v-1.776h-1.172A2.965,2.965,0,0,0,364.7,240.486Zm-.876,1.647a1.807,1.807,0,1,1-2.027-2.027A1.81,1.81,0,0,1,363.825,242.133Zm35.3,16.84,1.216-1.215-1.841-1.841-1.215,1.217a4.343,4.343,0,0,0-.766-.32V255.1h-2.6v1.717a4.351,4.351,0,0,0-.767.32l-1.215-1.217-1.841,1.841,1.217,1.215a4.354,4.354,0,0,0-.32.767h-1.717v2.6h1.717a4.343,4.343,0,0,0,.32.766l-1.217,1.217,1.841,1.839,1.215-1.215a4.347,4.347,0,0,0,.767.319v1.717h2.6v-1.717a4.339,4.339,0,0,0,.766-.319l1.215,1.215,1.841-1.839-1.216-1.217a4.339,4.339,0,0,0,.319-.766h1.717v-2.6h-1.717A4.35,4.35,0,0,0,399.126,258.972Zm-1.283,2.412a2.647,2.647,0,1,1-2.97-2.969A2.654,2.654,0,0,1,397.843,261.384Zm22.484-24.934,2.813-2.813-4.259-4.259-2.813,2.813a10.214,10.214,0,0,0-1.775-.739v-3.975H408.27v3.975a10.211,10.211,0,0,0-1.775.739l-2.813-2.813-4.259,4.259,2.813,2.813a10.214,10.214,0,0,0-.739,1.775h-3.975v6.023H401.5a10.283,10.283,0,0,0,.739,1.775l-2.813,2.813,4.259,4.259,2.813-2.813a10.212,10.212,0,0,0,1.775.739V255h6.023v-3.975a10.215,10.215,0,0,0,1.775-.739l2.813,2.813,4.259-4.259-2.813-2.813a10.282,10.282,0,0,0,.739-1.775h3.975v-6.023h-3.975A10.214,10.214,0,0,0,420.327,236.451Zm-2.97,5.584a6.128,6.128,0,1,1-6.873-6.873A6.139,6.139,0,0,1,417.357,242.035Z",
    transform: "translate(444.563 57.511)",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 46.253,
    cy: 46.253,
    r: 46.253,
    transform: "translate(660.196 105.318) rotate(-9.261)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(680.924 123.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M356.743,187.186a7.836,7.836,0,0,1-5.559-2.3l-14.635-14.633a7.861,7.861,0,1,1,11.117-11.117l9.077,9.074,28.81-28.81a7.861,7.861,0,0,1,11.117,11.117l-34.37,34.37A7.835,7.835,0,0,1,356.743,187.186Z",
    transform: "translate(-334.245 -137.093)",
    fill: "#ecc871"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M310.564,122.857l3.548,13.205,13.205,3.548-13.205,3.548-3.548,13.2-3.549-13.2-13.2-3.548,13.2-3.548Z",
    transform: "translate(279.979 -41.207)",
    fill: "#16d7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M308.837,141.818l1.257,4.68,4.68,1.258-4.68,1.258-1.257,4.68-1.258-4.68-4.68-1.258,4.68-1.258Z",
    transform: "translate(291.624 -16.917)",
    fill: "#16fce9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M296.6,130.2H250.816a100.55,100.55,0,0,0,94.777,83.679,54.51,54.51,0,0,0,5.758-24.437v-4.5A54.746,54.746,0,0,0,296.6,130.2Z",
    transform: "translate(224.9 -31.798)",
    fill: "#fec000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 79.731,
    cy: 79.731,
    r: 79.731,
    transform: "translate(474.301 1.919)",
    fill: "#130c28"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 72.249,
    cy: 72.249,
    r: 72.249,
    transform: "translate(481.783 9.401)",
    fill: "#b1ddff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 67.998,
    cy: 67.998,
    r: 67.998,
    transform: "translate(472.382 132.45) rotate(-76.888)",
    fill: "#e9f6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 17.088,
    height: 55.052,
    rx: 3.598,
    transform: "translate(545.488 21.561)",
    fill: "#0760ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    d: "M1.083,0H4.062A1.083,1.083,0,0,1,5.145,1.083V48.392a1.082,1.082,0,0,1-1.082,1.082H1.084A1.084,1.084,0,0,1,0,48.391V1.083A1.083,1.083,0,0,1,1.083,0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 555.231, 87.125)",
    fill: "#fedb00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 8.781,
    cy: 8.781,
    r: 8.781,
    transform: "translate(545.251 72.87)",
    fill: "#130c28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(0 27.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M59.022,145.474l3.548,13.205,13.205,3.548L62.57,165.776l-3.548,13.2-3.548-13.2-13.205-3.548,13.205-3.548Z",
    transform: "translate(-42.268 -39.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M109.193,181.221l2.15,8,8,2.15-8,2.15-2.15,8-2.15-8-8-2.15,8-2.15Z",
    transform: "translate(30.464 5.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M404.857,99.21l3.548,13.2,13.205,3.548-13.205,3.549-3.548,13.205-3.548-13.205L388.1,115.963l13.205-3.548Z",
    transform: "translate(400.778 -99.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M357.934,105l2.15,8,8,2.15-8,2.15-2.15,8-2.15-8-8-2.15,8-2.15Z",
    transform: "translate(349.124 -91.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M81.137,206.607l1.258,4.68,4.679,1.258L82.394,213.8l-1.258,4.68-1.258-4.68-4.68-1.258,4.68-1.258Z",
    transform: "translate(-0.08 38.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M125.351,177.571l1.258,4.679,4.679,1.258-4.679,1.258-1.258,4.68-1.258-4.68-4.68-1.258,4.68-1.258Z",
    transform: "translate(56.563 1.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M104.466,161.209l.923,3.437,3.437.923-3.437.924-.923,3.436-.924-3.436-3.436-.924,3.436-.923Z",
    transform: "translate(31.827 -19.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M104.223,219.782l1.258,4.68,4.68,1.258-4.68,1.257-1.258,4.68-1.258-4.68-4.679-1.257,4.679-1.258Z",
    transform: "translate(29.496 55.254)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/OBJECTS.db331fb93514cee7a581dcbaa952f914.svg";
export { ForwardRef as ReactComponent };